"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
const noop_1 = __importDefault(require("lodash/noop"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const fdr_lib_ident_with_auth_1 = require("@hotelplan/fdr.lib.ident.with-auth");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const fdr_share_form_utils_1 = require("./fdr-share-form.utils");
const useShareUrl_1 = __importDefault(require("./useShareUrl"));
const fdr_share_form_styles_1 = require("./fdr-share-form.styles");
const TIMEOUT_TO_SHOW_COPIED = 3000;
var CopyState;
(function (CopyState) {
    CopyState[CopyState["DEFAULT"] = 0] = "DEFAULT";
    CopyState[CopyState["SUCCESS"] = 1] = "SUCCESS";
    CopyState[CopyState["ERROR"] = 2] = "ERROR";
})(CopyState || (CopyState = {}));
const FdrShareForm = ({ className }) => {
    const [t] = (0, next_i18next_1.useTranslation)(['forms', 'common']);
    const [copyState, setCopyState] = (0, react_1.useState)(CopyState.DEFAULT);
    const shareUrl = (0, useShareUrl_1.default)();
    const { channelType } = (0, fdr_lib_ident_with_auth_1.useAuthentication)();
    const url = (0, fdr_share_form_utils_1.createUrlWithUtmParameters)(shareUrl, channelType);
    const copyTooltipText = (0, react_1.useMemo)(() => {
        switch (copyState) {
            case CopyState.SUCCESS:
                return t('forms:copied.button');
            case CopyState.ERROR:
                return t('forms:copiedWithError.button');
            default:
                return t('forms:copy.button');
        }
    }, [copyState, t]);
    const handleCopyButtonClick = () => {
        const isSuccess = (0, copy_to_clipboard_1.default)(url, { format: 'text/plain' });
        setCopyState(isSuccess ? CopyState.SUCCESS : CopyState.ERROR);
    };
    (0, react_1.useEffect)(function resetCopyStateOnTimeout() {
        const timerRef = { current: null };
        if (!timerRef.current && copyState === CopyState.SUCCESS) {
            timerRef.current = setTimeout(() => {
                // prevent setState on unmounted component
                if (!timerRef.current)
                    return;
                setCopyState(CopyState.DEFAULT);
            }, TIMEOUT_TO_SHOW_COPIED);
            return () => {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            };
        }
    }, [copyState]);
    return (react_1.default.createElement(fdr_share_form_styles_1.ShareFormWrap, { className: className },
        react_1.default.createElement("div", { className: "input-wrap" },
            react_1.default.createElement(components_common_text_input_1.TextInput, { label: t('common:share.label'), testId: 'sharing-url-id', value: url, onChange: noop_1.default, required: true, readOnly: true })),
        react_1.default.createElement(fdr_share_form_styles_1.CopyButton, { onClick: handleCopyButtonClick },
            t('forms:copy.button'),
            react_1.default.createElement(fdr_share_form_styles_1.CopyTooltip, null, copyTooltipText))));
};
exports.default = FdrShareForm;
//# sourceMappingURL=fdr-share-form.js.map